<template>
  <!-- TODO: esta clase se pueda cambiar, quitar este "TODO" cuando pases por aquí y actualizar el test -->
  <div class="report-form">
    <template v-if="currentStep === 1">
      <h3>¿Qué tipo de error has visto?</h3>

      <label for="report-syntax-error">
        <input type="radio" name="type" id="report-syntax-error" :value="1" v-model.number="type">
        Ortográfico o gramatical
      </label>
      <label for="report-data-error">
        <input type="radio" name="type" id="report-data-error" :value="2" v-model.number="type">
        Dato erroneo
      </label>

      <p>
        ¿La sugerencia que quieres realizar no está entre estas opciones? Puedes realizar otro tipo de consultas en <a :href="url" target="_blank">infolibre.es</a> responde.
      </p>
    </template>

    <template v-else>
      <h3><label for="report-text">{{labelTextStep}}</label></h3>
      <textarea id="report-text" v-model="text"></textarea>
      <p>Puedes consultar nuestras <a href="https://www.infolibre.es/aviso_legal/" target="_blank">normas de uso</a>.</p>
    </template>

    <nav>
      <button @click="cancel" class="prev">
        Cancelar
      </button>

      <button @click="accept" class="next" v-if="currentStep === 1">
        Siguiente
      </button>

      <template v-else>

        <button @click="accept" class="send" :disabled="!text || loading">
          <scale-loader :loading="loading" v-if="loading" color="#c4071b" height="10px"></scale-loader>
          <span v-else>Enviar</span>
        </button>
      </template>
    </nav>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import ScaleLoader from "vue-spinner/src/ScaleLoader";
  import {httpPost} from "../util";

  // Opciones del primer paso del formulario:
  const TYPE = {
    // Opción 1: Ortográfico o gramatical
    SYNTAX_ERROR: 1,
    // Opción 2: Dato erroneo
    WRONG_DATA: 2
  };

  // Pasos del formulario
  const STEP = {
    // El paso en el que se selecciona el tipo de error a reportar
    TYPES: 1,
    // El paso de introducir el texto del reporte
    TEXT: 2
  };

  export { TYPE, STEP };

  export default {
    props: {
      pageId: {
        type: Number,
        optional: true
      }
    },
    components: {
      ScaleLoader,
    },
    data() {
      return {
        errors: [],
        currentStep: STEP.TYPES,
        type: TYPE.SYNTAX_ERROR,
        text: '',
        loading: false
      }
    },
    computed: {
      labelTextStep() {
        if (this.type === TYPE.SYNTAX_ERROR) {
          return `Error ortográfico o gramatical`;
        }
        return `Dato erróneo`;
      },
      url() {
        // TODO: revisar procedencia de la noticia
        return 'https://www.infolibre.es/responde/Alguna-pregunta-infolibrees-responde_6_586251400.html';
      }
    },
    methods: {
      ...mapActions(['sendReport']),
      cancel() {
        if (this.currentStep === STEP.TYPES) {
          this.$emit('cancel');
        }
        if (this.currentStep === STEP.TEXT) {
          this.currentStep--;
        }
      },
      accept() {
        if (this.currentStep === STEP.TEXT && !this.loading) {
          this.loading = true;
          httpPost(
            `/api/report/content/${this.pageId}`,
            () => {
              this.$toasted.global.successReport();
              this.$emit('success');
            },
            { type: this.type, text: this.text }
          )
          .catch(err => {
            this.$toasted.global.commentError({ message: err });
            this.$emit('cancel');
          })
          .finally(() =>{
            this.loading = false;
          });
        }
        if (this.currentStep === STEP.TYPES) {
          this.currentStep++;
        }
      },
    }
  }
</script>
